// Models
import { calcDistanceBetweenUseCase } from './application/use-cases/calc-distance-between.use-case';
import {
    MapParams as MapParamsModel,
    MapCoords as MapCoordsModel,
    MapLocation as MapLocationModel,
} from './domain/models/map.models';
// Commands
import {
    LoadMapValues,
    MapMarkerClickedEvent,
    SetMapParams,
    SetMapSelectedShop,
    ToggleMapStateTooltip,
    SetMapTooltipState,
    SetMapValueTooltip,
    StartMapEffects,
    StopMapEffects,
} from './store/map.actions';
// Queries
import {
    getMapParams,
    getMapSelectedShop,
    getMapValues,
} from './store/map.selectors';
// UI
import {
    MapTooltipComponentOutput as MapTooltipComponentOutputModel,
} from './ui/components/tooltip/tooltip.component.models';

// #region PUBLIC API
export { StartMapEffects } from './store/map.actions';

export const MapPublicCommands = {
    LoadMapValues,
    SetMapParams,
    SetMapSelectedShop,
    SetMapTooltipState,
    SetMapValueTooltip,
    StartMapEffects,
    StopMapEffects,
    ToggleMapStateTooltip,
};

export const MapPublicQueries = {
    getMapParams,
    getMapSelectedShop,
    getMapValues,
};

export const MapPublicEvents = {
    MapMarkerClickedEvent,
};

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace MapPublicModels {
    export type MapCoords = MapCoordsModel;
    export type MapParams = MapParamsModel;
    export type MapLocation = MapLocationModel;
    export type MapTooltipComponentOutput = MapTooltipComponentOutputModel;
}

export const MapPublicUseCases = {
    calcDistanceBetweenUseCase,
};
// #endregion PUBLIC API
